export default __webpack_public_path__ + "static/media/home.91fcd09d.webp";